import { Component, OnInit } from '@angular/core';
import { IffShipmentSummaryService } from 'src/app/services/iff-shipment-summary/iff-shipment-summary.service';
import { Router } from '@angular/router';
import { IFFShipmentSummaryResponse, PageResponse } from 'src/app/shared/common-components/common-structure';
import { ColDef, ColGroupDef, IDatasource, IGetRowsParams, GridOptions } from 'ag-grid-community';
import { Observable, map } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { IffShipmentDetailsService } from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import {CommonHelpers} from "../../../shared/common-helpers";

@Component({
    selector: 'app-hhg-iff-summary',
    templateUrl: './hhg-iff-summary.component.html',
    styleUrls: ['./hhg-iff-summary.component.css'],
    standalone: false
})
export class HhgIffSummaryComponent implements OnInit {

  constructor(private iffShipmentSummaryService: IffShipmentSummaryService,  private iffShipmentDetailsService: IffShipmentDetailsService,
    private router: Router) { }

  updateHHGShipmentPaginationRequestFn = this.iffShipmentSummaryService.updateHHGShipmentPaginationRequest;
  HHGShipmentPaginationResults$ = this.iffShipmentSummaryService.HHGShipmentMasterResults$.pipe(
    map((t: any) => {
      if (t.content !== null && t.content !== undefined && t.content.length > 0) {
        return CommonHelpers.sortAtoZByYearByQtr(t.content);
      }
    })
  )

  updateHHGIffShipmentDetailRequestFn = this.iffShipmentDetailsService.updateHHGIffShipmentDetailRequestFn;
  hhgIFFShipmentDetailResults$ = this.iffShipmentDetailsService.hhgIFFShipmentDetailResults$;
  ngOnInit() {
  }

  getHHGIffShipmentDetailsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {headerName: 'SCAC', field: 'scac', filter: 'agTextColumnFilter', sortable: true },
      {headerName: 'TSP Name', field: 'scacName', filter: 'agTextColumnFilter', sortable: true },
      {headerName: 'FAIC ', field: 'faicCode', filter: 'agNumberColumnFilter', sortable: true},
      {headerName: 'Agency Bureau Name', field: 'agencyBureauName', filter: 'agTextColumnFilter', sortable: true},
      {headerName: 'Pro Bill Number', field: 'proBillNumber', filter: 'agTextColumnFilter', sortable: true },
      {headerName: 'BOL', field: 'bolNumber', filter: 'agTextColumnFilter', sortable: true},
      {headerName: 'GBL/CBL', field: 'gblcbl', filter: 'agTextColumnFilter', sortable: true},
      {headerName: 'Move Type', field: 'moveType', filter: 'agTextColumnFilter', sortable: true },
      {headerName: 'Pickup Date', field: 'pickupDate', filter: 'agDateColumnFilter', sortable: true },
      {headerName: 'Delivery Date', field: 'deliveryDate', filter: 'agDateColumnFilter', sortable: true },
      {headerName: 'Origin', field: 'originStateCode', filter: 'agTextColumnFilter', sortable: true},
      {headerName: 'Destination', field: 'destinationStateCode', filter: 'agTextColumnFilter', sortable: true},
      {headerName: 'Last Name', field: 'employeeLastName', filter: 'agTextColumnFilter', sortable: true },
      {headerName: 'Weight', field: 'weight', filter: 'agNumberColumnFilter', sortable: true },
      {headerName: 'Miles', field: 'miles', filter: 'agNumberColumnFilter', sortable: true },
      {headerName: 'Discount', field: 'discount',filter: 'agNumberColumnFilter', sortable: true,
        valueFormatter: this.iffShipmentSummaryService.percentageFormatter },
      {headerName: 'Gross Amount', field: 'grossAmount', filter: 'agNumberColumnFilter', sortable: true,
        valueFormatter: this.iffShipmentSummaryService.formatNumber },
      {headerName: 'Net Amount', field: 'netAmount', filter: 'agNumberColumnFilter', sortable: true,
        valueFormatter: this.iffShipmentSummaryService.formatNumber},
      {headerName: 'Pass Thr amt', field: 'passThruAmount', filter: 'agNumberColumnFilter', sortable: true,
        valueFormatter: this.iffShipmentSummaryService.formatNumber},
      {headerName: 'Total AF', field: 'totalIFF', filter: 'agNumberColumnFilter', sortable: true,
        valueFormatter: this.iffShipmentSummaryService.formatNumber},
      {headerName: 'Payment Status', field: 'paymentStatus', filter: 'agTextColumnFilter', sortable: true,
        valueFormatter: this.iffShipmentSummaryService.formatNumber},
      {headerName: 'Payment Date', field: 'paymentDate', filter: 'agDateColumnFilter', sortable: true,
        valueFormatter: this.iffShipmentSummaryService.formatNumber}
    ];
  }

  OnHHGShipmentSelected(IFFShipmentSelected: IFFShipmentSummaryResponse) {
    this.iffShipmentSummaryService.updateSelectedHHGShipmentSummary(IFFShipmentSelected);
    this.router.navigate(['/', 'hhgIffDetail'],
    { queryParams: { iffMasterId : IFFShipmentSelected.iffMasterId}});
  }

  OnDelinquencyReportSelected() {
    console.log(this.router);
    this.router.navigate(['/', 'hhgDelinquency']);
  }
  OnComprehensiveReportSelected() {
    this.router.navigate(['/', 'hhgComprehensiveReport']);
  }

}
